// extracted by mini-css-extract-plugin
export default {"font-renta":"Warehouses_font-renta__il408","warehouses":"Warehouses_warehouses__6Vj7K","toolbar":"Warehouses_toolbar__7VbA5"};